"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alfonsine": {
    "aa47258b": [{
      "hkey": "74b123ce",
      "slug": "alfonsine",
      "name": "Alfonsine",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-cavallotti": [{
      "hkey": "74b123ce",
      "slug": "alfonsine",
      "name": "Alfonsine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d51375fa": [{
      "hkey": "74b123ce",
      "slug": "alfonsine",
      "name": "Alfonsine",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-fratti": [{
      "hkey": "74b123ce",
      "slug": "alfonsine",
      "name": "Alfonsine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;